<template>
  <el-container>
    <el-header class="modern-header"  >
      <div class="header-container">
        <!-- Logo区域 -->
        <div class="logo-section" style="margin-left: -5px;">
          <router-link to="/home/" class="logo-link">
            <img v-if="isTangelo" src="../assets/pomelo.png" class="logo-img" alt="TANGELO" />
            <img v-else src="../assets/pomelo.png" class="logo-img" alt="Logo" />
          </router-link>
          <!-- <div class="brand-text">
            <span class="brand-name">TANGELO</span>
            <span class="brand-subtitle">媒体管理系统</span>
          </div> -->
        </div>

        <!-- 导航菜单 -->
        <div class="nav-section" v-if="!isMiddleMode">
          <el-menu
            router
            :default-active="activeIndex"
            class="modern-menu"
            mode="horizontal"
            background-color="transparent"
            text-color="#eee"
            active-text-color="#f4d03f">
            <el-menu-item index="1" route="/home" class="nav-item">
              <i class="el-icon-s-home"></i>
              <span>首页</span>
            </el-menu-item>
            <el-menu-item index="2" route="/home/creative" class="nav-item">
              <i class="el-icon-folder-opened"></i>
              <span>创意管理</span>
            </el-menu-item>
            <el-menu-item index="3" route="/home/delivery" class="nav-item">
              <i class="el-icon-s-promotion"></i>
              <span>3+Reach</span>
            </el-menu-item>
            <el-menu-item index="4" route="/home/report" class="nav-item">
              <i class="el-icon-s-data"></i>
              <span>数据报告</span>
            </el-menu-item>
            <el-menu-item index="5" route="/home/setting/commonsetting" class="nav-item">
              <i class="el-icon-setting"></i>
              <span>策略管理</span>
            </el-menu-item>
          </el-menu>
        </div>

        <!-- 用户信息区域 -->
        <div class="user-section" v-if="!isMiddleMode">
          <div class="user-info">
            <i class="el-icon-user-solid"></i>
            <span class="welcome-text">欢迎</span>
            <span class="user-name">{{getCookies(mediaCompany)}}</span>
          </div>
          <el-button @click="quits" class="logout-btn" type="text">
            <i class="el-icon-switch-button"></i>
            <span>退出</span>
          </el-button>
        </div>
      </div>
    </el-header>
    <el-container style="height:auto;" >

      <el-main>
        <transition name="move" mode="out-in"><router-view></router-view></transition>
      </el-main>
    </el-container>
    <el-dialog title="通知消息" :visible.sync="dialogTableVisible">
      <el-table :data="gridData">
        <el-table-column property="notic_title" label="标题" width="150"><router-link to="/" ></router-link></el-table-column>
        <el-table-column property="notic_content" label="内容" width="200"></el-table-column>
        <el-table-column property="create_time" label="日期"></el-table-column>
      </el-table>
      <div style="text-align:center;margin-top:20px;"><router-link to="" ><el-button type="primary" plain>查看全部消息</el-button></router-link></div>
    </el-dialog>
  </el-container>
  </template>
<script>
import {mapState} from 'vuex'
export default {
  name: 'App',
  data () {
    return {
      isTangelo: false,
      hh: '100px',
      uid: this.getCookies("mediaUid"),
      boundaryLeft: '200px',
      ss: '1', // 导航默认选中
      userinfo: 'd',
      shownoc: false,
      tableData: 1,
      isCollapse: false,
      widths: {width: '200px'},
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }],
      dialogTableVisible: false // 通知消息是否显示
    }
  },
  computed: {
    ...mapState([
      'userData',
      'username'
    ]),
    // 判断是否为中间页模式
    isMiddleMode() {
      return this.getCookies('setMiddle') === 'yes'
    },
    activeIndex() {
        const name = this.$route;
        if (name.path === "/home") {
          return "1"
        } else if (name.path.indexOf("/home/creative") > -1) {
          return "2"
        } else if (name.path.indexOf("/home/delivery") > -1) {
          return "3"
        } else if (name.path.indexOf("/home/report") > -1) {
          return "4"
        } else if (name.path.indexOf("/home/setting") > -1) {
          return "5"
        }
        return "1" // 默认返回首页
    }
  },
  methods: {
    handleOpen (key, keyPath) {
    },
    handleClose (key, keyPath) {
    },
    usele (index, path) { // 导航选择事件
      // alert(index)
    },
    quits () {
      this.$store.commit('logout')
      this.$router.push('/login')
    },
    showmenu () {
      if (this.isCollapse) {
        this.isCollapse = false
        this.widths = {width: '200px'}
        this.boundaryLeft = '200px'
      } else {
        this.isCollapse = true
        this.widths = {width: '80px'}
        this.boundaryLeft = '80px'
      }
    }
  },
  mounted () {
    // console.log(this.$store)
    // this.tongzhi()
    // this.noticeApi()
    let url = window.location.href
    if(url.includes('tangelo')) this.isTangelo = true
    if(url.includes('otthink')) this.isTangelo = false
  },
  created: function () {
  }
}
</script>

<style>
.mbx{height: 30px;}
.step-user{margin-bottom: 30px;}
*{padding:0px;margin:0px;font-size:12px;}
.el-container{height:100%;}
.el-menu-item{
  height: 50px !important;
  line-height: 50px !important;
}
/* .el-menu-item i{
  margin-top:-3px;
}
.el-menu-item span{
  font-size: 14px !important;
} */
.el-menu--horizontal>.el-menu-item{border-bottom: 0px !important;}
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus {
  /* color: #ffffff !important; */
  background-color: transparent !important;
  border-bottom-color: transparent !important;
}
.el-menu--horizontal .el-menu-item.is-active {
  /* color: #ffffff !important; */
  border-bottom: none !important;
  background-color: transparent !important;
  border-bottom: transparent !important;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
  height:100%;
}
.el-button{
    padding: 7px 15px;
    border-radius: 0px;
}
.el-button--primary{
  background-color: #409EFF;
  border-color: #409EFF;
  padding: 7px 15px;
  border-radius: 0px;
}
.el-button--text{
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.el-tag.el-tag--info{
  color: #000;
}
.el-button--primary:hover{
  background-color: #409EFF;
  border-color: #409EFF;
}
.el-button--primary:focus{
  background-color: #409EFF;
  border-color: #409EFF;
}
.el-button--primary.is-active{
  background-color: #409EFF;
  border-color: #409EFF;
}
.el-input__inner{
  height: 30px;
  border-radius: 0px;
  line-height: 30px;
  color: #000;
}
.el-select .el-input .el-select__caret{
  line-height: 30px;
}
.el-input__icon{
  line-height: 30px;
}
.el-radio-button:last-child .el-radio-button__inner{
  border-radius: 0px;
}
.el-radio-button:first-child .el-radio-button__inner{
  border-radius: 0px;
}
.el-button--mini{
  border-radius: 0px;
}
.el-table thead{
  color: #3f3b3b;
  font-size:16px;
}
.el-table tr{
  color: #3f3b3b;
  font-weight: 500;
}
.el-button--text{
  /* color: #1C3293FF; */
}
.el-button--text:hover{
  /* color: #1C3293FF; */
}
  .el-header {
    background-color: #19233c;
    color: #fff;
    text-align: left;
    line-height: 1;
    padding: 0;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    position: relative;
    z-index: 1000;
  }

  .modern-header {
    height: 50px !important;
  }

  .header-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    padding: 0 15px;
    margin: 0 auto;
  }
  /* max-width: 1400px; */

  /* Logo区域 */
  .logo-section {
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .logo-link {
    display: flex;
    align-items: center;
  }

  .logo-img {
    height: 40px;
    width: auto;
    transition: transform 0.3s ease;
  }

  .logo-img:hover {
    transform: scale(1.05);
  }

  .brand-text {
    display: flex;
    flex-direction: column;
    line-height: 1.2;
  }

  .brand-name {
    font-size: 20px;
    font-weight: 700;
    color: #ffffff;
    letter-spacing: 1px;
  }

  .brand-subtitle {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.8);
    font-weight: 400;
  }

  /* 导航区域 */
  .nav-section {
    flex: 1;
    display: flex;
    justify-content: center;
  }

  .modern-menu {
    border: none !important;
    background: transparent;
  }

  .modern-menu .el-menu-item {
    border: none !important;
    border-bottom: none !important;
    padding: 0 25px;
    height: 45px;
    line-height: 45px;
    margin: 0 5px;
    border-radius: 25px;
    transition: all 0.3s ease;
    font-weight: 500;
    font-size: 15px;
    position: relative;
  }

  .modern-menu .el-menu-item:hover {
    /* background: rgba(255, 255, 255, 0.15) !important; */
    /* color: #ffffff !important; */
  }

  .modern-menu .el-menu-item:focus {
    /* background: rgba(255, 255, 255, 0.15) !important; */
    /* color: #ffffff !important; */
  }

  .modern-menu .el-menu-item.is-active {
    /* color: #ffffff !important; */
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }
/** 这是底部导航 */
  /* .modern-menu .el-menu-item.is-active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 3px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 2px;
  } */

  .nav-item i {
    margin-right: 8px;
    font-size: 16px;
  }

  /* 用户区域 */
  .user-section {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(255, 255, 255, 0.9);
    font-size: 14px;
  }

  .user-info i {
    font-size: 16px;
  }

  .welcome-text {
    font-weight: 400;
  }

  .user-name {
    font-weight: 600;
    color: #ffffff;
  }

  .logout-btn {
    color: rgba(255, 255, 255, 0.9);
    padding: 8px 16px;
    border-radius: 20px;
    transition: all 0.3s ease;
    font-weight: 500;
  }

  .logout-btn:hover {
    /* background: rgba(255, 255, 255, 0.15); */
    color: #ffffff;
  }

  .logout-btn i {
    margin-right: 6px;
    font-size: 14px;
  }
  .el-footer{
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  .asidess{
    width:200px;border-right: 0px solid #ccc;overflow: hidden; min-height: 100%;
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    background-color: #fff;
    color: #333;
    text-align: left;
    /*position: fixed;
    height:100%;*/
    /*border-top: 1px solid #ccc;*/
    /*width:200px;*/
  }
  .el-main {
    /* background-color: #f5f5f552; */
    background-color: #f5f7f9;
    color: #333;
    text-align: left;
    height:100%;
    /*margin-left:200px;*/
    padding:0px !important;
  }
  .el-main .container-div{padding:20px;}
  .boundary{
    position: fixed;
    border-right: 1px solid #ccc;
    height: 100%;
    left: 200px;
    top: 0;
    z-index: 0;
  }
  .el-table .cell{
    color: #000 !important;
    text-overflow: clip;
  }
  a{
    text-decoration: none;
    color:#333;
  }
  .el-menu-item.is-active a{
    color:#1276e5;
  }
  body > .el-container {
    /*margin-bottom: 40px;*/
    min-height: 1000px;
  }
  .home-nav-btn {
    position: relative;
    font-size: 16px;
    background-color: transparent;
    outline: none;
    border: 0;
  }
  .home-nav-notification{
    right: 20px;
    color: black;
  }
  .home-nav-logout{
    color: #fff;
  }
  .home-nav-welcome{
    color: black;
  }
  .logo-class{
    vertical-align: middle;
    height: 30px;
    width: 100px;
  }
  .r{float:right;}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue